import {Component, Input, OnInit} from '@angular/core';
import {BlogArticle} from '../../shared/models/blogArticle/blogArticle.model';
import {Search} from '../../shared/models/search/search.model';
import {BlogArticleService} from '../../shared/services/blogArticle.service';
import {Subject} from 'rxjs/Subject';
import {LoadingService} from '../../shared/services/loading.service';
import {NavController} from 'ionic-angular';

@Component({
    selector: 'core-blog-article-list',
    templateUrl: './blog-article-list.component.html'
})
export class BlogArticleListComponent implements OnInit {
    @Input() searchQuery$: Subject<Search> = null;
    public blogArticles: Array<BlogArticle>;
    public totalPages: boolean = false;
    public isLoading = new Subject();
    public noResult = false;
    public filters: Search = new Search({
        term: '',
        themes: [],
        favoris: null,
        orderBy: 'date',
        order: 'desc',
        type: null,
        home: 1,
        offset:  0,
        limit: 15
    });

    constructor(
        public navCtrl: NavController,
        private blogArticleService: BlogArticleService,
        private loadingService: LoadingService
    ) {

    }

    ngOnInit(): void {
        this.initializeBlogArticles();
    }

    initializeBlogArticles() {
        this.searchQuery$.debounceTime(500)
            .distinctUntilChanged()
            .switchMap(search => {
                return this.blogArticleService.searchAll(search, search.action);
            }).subscribe(response => {
            const data = response.data;
            const action = response.action;

            if (action === 'scroll' && data.data.length > 0) {
                for (let i = 0; i < data.data.length; i++) {
                    this.blogArticles.push(data.data[i]);
                }
                this.totalPages = data.data.length < this.filters.limit;
                this.filters.offset += this.filters.limit;
                this.isLoading.next();
            } else if (action === 'scroll' && data.data.length === 0) {
                this.totalPages = true;
                this.isLoading.next();
            } else {
                this.blogArticles = data.data;
                this.totalPages = data.data.length < this.filters.limit;
                this.noResult = data.data.length === 0;
                this.filters.offset = this.filters.limit;
            }
            this.loadingService.end();
        });
    }

    doInfinite(infiniteScroll) {
      this.filters.action = 'scroll';
      this.searchQuery$.next(this.createSearchQuery('scroll'));

      this.isLoading.first().subscribe(() => {
          infiniteScroll.complete();
      });
    }

    onClick(id) {
        this.navCtrl.push('BlogArticleDetailPage', { blogArticle: id });
    }

    clickBlogArticleUrl(url) {
        if (url) {
            window.open(url, '_system');
        }
    }

  createSearchQuery(action: string): Search {
    const params = {
      action: action,
      home: 1,
      type: this.filters.type,
      limit: this.filters.limit,
      offset: this.filters.offset,
      favoris: this.filters.favoris,
      order: this.filters.order,
      orderBy: this.filters.orderBy
    };
    return new Search(params);
  }
}



// WEBPACK FOOTER //
// ./src/core/blog-article-list/blog-article-list.component.ts